const SET_POLICY_FORM = 'SET_POLICY_FORM'
const SET_POLICY_ID = 'SET_POLICY_ID'

const state = {
  policyForm: null,
  policyId: ''
}

const mutations = {
  [SET_POLICY_FORM]: (state, value) => {
    state.policyForm = value
  },
  [SET_POLICY_ID]: (state, value) => {
    state.policyId = value
  },
}

const actions = {
  setPolicyForm({ commit }, val) {
    commit(SET_POLICY_FORM, val)
  },
  setPolicyId({ commit }, val) {
    commit(SET_POLICY_ID, val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}